/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AorCancellationStatus {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  CONFIRMED_BY_EMPLOYEE = 'CONFIRMED_BY_EMPLOYEE',
  AWAITING_EMPLOYEE = 'AWAITING_EMPLOYEE',
}
